import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const PriceQuotesSavedDetailDocument = gql`
  query PriceQuotesSavedDetail($priceQuoteId: uuid!) {
    getPriceQuote(price_quote_id: $priceQuoteId) {
      account_name
      chat_id
      competitor_name
      currency_code
      line_items {
        competitor {
          item_name
          pack_price_in_micros
          pack_size
          savings_in_micros
        }
        currency_code
        is_catalog_item_removed
        item_code
        item_description
        item_name
        item_pack_size
        line_item_id
        line_total_in_micros
        pack_price_in_micros
        per_unit_price_in_micros
        quantity
        variant_pack_id
      }
      name
      price_quote_id
      quote_type
      total_amount_in_micros
      total_savings_in_micros
      updated_at
    }
  }
`;
export function usePriceQuotesSavedDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PriceQuotesSavedDetailQuery,
    Types.PriceQuotesSavedDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PriceQuotesSavedDetailQuery,
    Types.PriceQuotesSavedDetailQueryVariables
  >(PriceQuotesSavedDetailDocument, options);
}
export function usePriceQuotesSavedDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PriceQuotesSavedDetailQuery,
    Types.PriceQuotesSavedDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PriceQuotesSavedDetailQuery,
    Types.PriceQuotesSavedDetailQueryVariables
  >(PriceQuotesSavedDetailDocument, options);
}
export type PriceQuotesSavedDetailQueryHookResult = ReturnType<
  typeof usePriceQuotesSavedDetailQuery
>;
export type PriceQuotesSavedDetailLazyQueryHookResult = ReturnType<
  typeof usePriceQuotesSavedDetailLazyQuery
>;
export type PriceQuotesSavedDetailQueryResult = Apollo.QueryResult<
  Types.PriceQuotesSavedDetailQuery,
  Types.PriceQuotesSavedDetailQueryVariables
>;

/**
 * Wrapped version of useGeneratedPriceQuotesSavedDetailQuery using Pepper's useWrappedQuery
 */
export function useGeneratedPriceQuotesSavedDetailQuery(
  options?: Apollo.QueryHookOptions<
    Types.PriceQuotesSavedDetailQuery,
    Types.PriceQuotesSavedDetailQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.PriceQuotesSavedDetailQuery,
    Types.PriceQuotesSavedDetailQueryVariables
  >(PriceQuotesSavedDetailDocument, options);
}

/**
 * Wrapped version of useGeneratedPriceQuotesSavedDetailLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedPriceQuotesSavedDetailLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.PriceQuotesSavedDetailQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.PriceQuotesSavedDetailQuery,
    Types.PriceQuotesSavedDetailQueryVariables
  >(PriceQuotesSavedDetailDocument, lazyOptions);
}
